
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-v2/[slug]/[view]",
      function () {
        return require("private-next-pages/profile-v2/[slug]/[view].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile-v2/[slug]/[view]"])
      });
    }
  